import { BreadcrumsProps } from '../interface/interface';

const Breadcrumbs = (props: Readonly<BreadcrumsProps>) => {
  return (
    <nav className={`flex mb-4`} aria-label="Breadcrumb">
      <ol className="inline-flex items-center flex-wrap">
        {props?.data?.map((e, index) => (
          <li
            key={index}
            className="flex items-center text-sm text-primary-blue-500 font-regular py-1"
          >
            {index > 0 && (
              <span
                className={`${props?.hasBanner ? 'mt-8 md:mt-0' : ''} mr-3`}
              >
                /
              </span>
            )}
            <e.tag
              className={`${e?.className ?? ''} inline-flex items-center whitespace-nowrap`}
              {...(e.href ? { href: e.href } : {})}
            >
              {e.children}
            </e.tag>
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
